import React from 'react';

import { LocationDescriptor } from 'history';
import { FormattedMessage } from 'react-intl';

import { AuthState } from 'services/hoc/b2c/withAuthentication/withAuthentication.const';
import { BamOnlineCTACommonProps } from 'types/bamOnlineCTA';

import { StyledLink } from './BamOnlineLink.style';

type Props = BamOnlineCTACommonProps & {
  to: LocationDescriptor<{ authState: AuthState }>;
};

const BamOnlineLink: React.FC<Props> = ({
  translationId,
  translationValues,
  to,
  secondary = false,
  light = false,
  className,
}) => {
  return (
    <StyledLink className={className} secondary={secondary} light={light} to={to}>
      <FormattedMessage id={translationId} values={translationValues} />
    </StyledLink>
  );
};

export default BamOnlineLink;
